// client/src/pages/admin/AdminRevenue.js
import { useEffect, useState } from "react";
import api from "../../api/axiosInstance";

export default function AdminRevenue() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/admin/revenue")
      .then((res) => setData(res.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div>Loading revenue…</div>;
  if (!data) return <div>No data</div>;

  const { cards, byService } = data;

  return (
    <div className="space-y-8">
      <h1 className="text-2xl font-bold">Revenue Dashboard</h1>

      {/* ===== SUMMARY CARDS ===== */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card title="Total Sales" value={`₹${(Number(cards.totalSales) || 0).toFixed(2)}`} />
        <Card
          title="Provider Cost"
          value={`₹${(Number(cards.totalProviderCost) || 0).toFixed(2)}`}
        />
        <Card
          title="Net Profit"
          value={`₹${(Number(cards.totalProfit) || 0).toFixed(2)}`}
          highlight
        />
      </div>

      {/* ===== SERVICE PROFIT TABLE ===== */}
      <div className="card-glass p-4">
        <h2 className="font-semibold mb-4">Profit by Service</h2>

        <table className="w-full text-sm">
          <thead className="text-gray-400 border-b border-white/10">
            <tr>
              <th className="text-left py-2">Service</th>
              <th>Orders</th>
              <th>Sales</th>
              <th>Profit</th>
            </tr>
          </thead>
          <tbody>
            {byService.map((s) => (
              <tr
                key={s.service}
                className="border-b border-white/5"
              >
                <td className="py-2">{s.service}</td>
                <td className="text-center">{s.orders}</td>
                <td className="text-center">₹{s.sales.toFixed(2)}</td>
                <td className="text-center text-green-400">
                  ₹{s.profit.toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Card({ title, value, highlight }) {
  return (
    <div
      className={`card-glass p-4 ${
        highlight ? "border border-green-500/40" : ""
      }`}
    >
      <div className="text-sm text-gray-400">{title}</div>
      <div className="text-2xl font-bold">{value}</div>
    </div>
  );
}
